<template>
  <div name="outcomeedit" class="inner">
    <innertopbar @close="closeWindow()">
      <template v-slot:breadcrumb>
        <router-link to="notices"> Notices </router-link>
        <i class="carret fas fa-caret-right"></i> {{ barTitle }}
      </template>

      <template v-slot:listitems>
        <li
          v-if="!newAddition"
          @click="deletion"
          v-tooltip="{
            content: 'Delete Notice',
            placement: 'bottom-center',
            offset: 5,
            classes: ['tooltip-info'],
          }"
          title="Delete Notice"
          class="action-list-item inline-block hover:opacity-100"
        >
          <i class="pt-4 fas fa-trash-alt" title="Delete Notice"></i>
        </li>

        <li
          v-if="!newAddition && 1 == 2"
          class="inline-block mx-4 text-2xl text-gray-400"
        >
          |
        </li>

        <li class="inline-block mx-4">
          <button
            @click="submitForm()"
            type="button"
            class="publish-button hover:opacity-75"
          >
            Publish Changes
          </button>
        </li>
      </template>
    </innertopbar>

    <transition name="fade">
      <div class="loading" v-show="isSaving">
        <span class="fa fa-spinner fa-spin"></span> Saving
      </div>
    </transition>

    <form v-on:submit.prevent="submitNotice" id="outcomeForm" ref="form">
      <div class="w-full mx-auto grid grid grid-flow-col grid-cols-2 gap-20">
        <div class="mt-6 ml-10 p-8 bg-white rounded-lg mb-10">
          <div class="w-95p mx-auto">
            <h2 class="w-full text-xl mb-8 -mx-3 pt-4 font-bold text-gray-700">
              Notice Information
            </h2>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Notice Outline
                </label>
                <textarea
                  v-model="outline"
                  class="p-2 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-title"
                  type="text"
                  placeholder="Enter outline"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Notice Title
                </label>
                <input
                  v-model="title"
                  class="p-2 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-title"
                  type="text"
                  placeholder="Enter title"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title"> Main content</label>

                <div class="flex flex-wrap w-full">
                  <vue-editor
                    :editorToolbar="customToolbar"
                    class="mb-2 pb-8 focus:border-red-200 focus:bg-white focus:outline-none w-full"
                    v-model="content"
                    id="grid-space"
                    placeholder="Enter notice post content"
                  ></vue-editor>
                </div>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Visible On System
                </label>
                <button
                  type="button"
                  class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-check"
                  v-bind:class="[
                    true === isActive
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isActive = true"
                >
                  Active
                </button>

                <button
                  type="button"
                  class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-times"
                  v-bind:class="[
                    false === isActive
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isActive = false"
                >
                  Off
                </button>
                <p class="text-red-300 text-xs mt-1 italic">
                  Please fill out this field.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="p-6 px-8 bg-white mb-3">
          <div class="w-95p mx-auto">
            <savenotice
              :title="'Notice'"
              ref="saveNotice"
              class="right"
            ></savenotice>

            <h2 class="w-full text-xl mb-4 -mx-3 pt-4 font-bold text-gray-700">
              Notice Visibility
            </h2>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Notice Assignment
                </label>
                <button
                  type="button"
                  class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue disabled:opacity-50 disabled:cursor-not-allowed"
                  v-bind:class="[
                    !schoolShareOnly
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="schoolShareOnly = false"
                >
                  <i
                    class="fas"
                    v-bind:class="
                      !schoolShareOnly ? 'fa-check-circle' : 'fa-dot-circle'
                    "
                  ></i>
                  Available to everyone
                </button>

                <button
                  type="button"
                  class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue disabled:opacity-50 disabled:cursor-not-allowed"
                  v-bind:class="[
                    schoolShareOnly
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="schoolShareOnly = true"
                >
                  <i
                    class="fas"
                    v-bind:class="
                      schoolShareOnly ? 'fa-check-circle' : 'fa-dot-circle'
                    "
                  ></i>
                  School Share Based
                </button>
              </div>
            </div>

            <div class="mt-0 w-full mb-10" v-if="schoolShareOnly">
              <div class="flex flex-wrap -mx-3 mb-8">
                <div class="w-full">
                  <div class="flex justify-between w-full">
                    <label class="form-label" for="grid-title">
                      School selection - 
                      ({{ selectedSchools.length }})
                    </label>

                    <div class="mr-1">
                      <button
        @click="showModalAddition = true"
        type="button"
        class="text-action-blue opacity-75 cursor-pointer hover:opacity-50 wide focus:outline-none"
      >
          <i class="fas fa-plus"></i>
      </button>
                    </div>
                  </div>
   <div class="h-screen overflow-y-auto">
                  <table class="w-full table-wrapper my-4">
                    <tbody>
                      <tr v-for="item in selectedSchools" :key="item.id">
                        <td class="w-1">
                          <i
                            @click="selectSchool(item)"
                            class="fas fa-trash text-red-400 cursor-pointer"
                          ></i>
                        </td>
                        <td>{{ item.name }}</td>
                        
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <ModalSlide :show="showModalAddition" @closeModal="closeAddSchools">
      <template v-slot:header-icon>
        <i class="fas fa-plus"></i>
      </template>
      <template v-slot:header-title>
        Add Schools
        <div class="text-xs">Schools with Post viewing.</div>
      </template>
      <template v-slot:body>
        <div>
          <div class="flex w-7/12">
            <div>
              <dropdown
                :options="typeList"
                :selected="typeSelected"
                v-on:updateOption="userDidSelectType"
                class="w-56 bg-gray-200 text-center"
                v-bind:class="typeSelected.id > 0 ? 'text-gray-700 ' : ''"
              >
                ></dropdown
              >
            </div>
            <div class="w-10 text-center flex-1 ...">OR</div>
            <div>
              <dropdown
                :options="orgDropdown"
                :selected="orgSelected"
                v-on:updateOption="userDidSelectOrg"
                class="w-80 bg-gray-200 text-center"
                v-bind:class="orgSelected.id > 0 ? 'text-gray-700 ' : ''"
              >
                ></dropdown
              >
            </div>
          </div>

          <div class="h-screen overflow-y-auto">
            <table class="w-full table-wrapper my-8">
              <thead class="text-primary bg-gray-100 h-10">
                <tr>
                  <th class="selectable w-2/12" @click="setSelectAll()">
                    <i
                      class="far text-base"
                      v-bind:class="[
                        selectAll ? 'fa-check-circle on' : 'fa-circle',
                      ]"
                    ></i>
                    <span class="pl-2 text-xs opacity-75">Select All</span>
                  </th>

                  <th class="pl-2 font-bold w-10/12">Schools</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in filteredList"
                  :key="item.id"
                  class="hover:opacity-50 cursor-pointer"
                >
                  <td class="selectable" @click="selectSchool(item)">
                    <i
                      class="pl-3 far text-base"
                      v-bind:class="[
                        isSelected(item) ? 'fa-check-circle on' : 'fa-circle',
                      ]"
                    ></i>
                  </td>
                  <td class="w-7/12">{{ item.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </ModalSlide>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";

const dropdown = () => import("@/components/Dropdown.vue");
const savenotice = () => import("@/components/SaveNotice.vue");
const innertopbar = () => import("@/components/InnerTopBar.vue");
const ModalSlide = () => import("@/components/ModalSlide.vue");

import { BaseService } from "@/services/school.service";
import { PostService } from "@/services/post.service";
import { calendarYearList } from "@/assets/js/utils";

export default {
  name: "noticeedit",
  props: {
    newAddition: Boolean,
    noticeObject: Object,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      settings: "settings",
    }),
    isDisabled() {
      if (this.outline.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    barTitle() {
      if (this.newAddition) {
        return "Add new notice";
      } else {
        return this.title.length > 0
          ? this.title.substring(0, 40) + "..."
          : this.title;
      }
    },
    filteredList() {
      let list = _.orderBy(this.schoolList, ["name"]);
      return list.filter((item) => {
        var vm = this;
        return item.name.toLowerCase().includes(vm.search.toLowerCase());
      });
    },
    orgDropdown() {
      var results = [{ id: 0, name: "Select an Organisation" }].concat(
        this.organisationList
      );

      if (this.orgSelected.id === undefined) {
        this.orgSelected = results[0];
      }

      return results;
    },
  },
  data() {
    return {
      selectAll: false,
      loading: true,
      errored: false,
      errorNotice: "",
      isActive: true,
      search: "",
      title: "",
      outline: "",
      content: "",
      isSaving: false,
      schoolShareOnly: false,
      showModalAddition: false,
      schoolList: [],
      selectedSchools: [],
      typeSelected: null,
      orgSelected: {},
      organisationList: [],
      typeList: [
        { id: 0, key: "", name: "Select a type" },
        { id: 1, key: "subscribed", name: "Primary" },
        { id: 2, key: "trial", name: "Trial" },
        { id: 3, key: "secondary", name: "Secondary" },
        { id: 4, key: "international", name: "International" },
      ],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["code-block"],
        ["clean"],
      ],
    };
  },
  created() {
    this.selectedCriteria = this.settings.assessmentCriteriaList[0];
    this.typeSelected = this.typeList[0];

    if (this.newAddition == false) {
      if (this.noticeObject == undefined) {
        this.closeWindow();
        return;
      } else {
        this.title = this.noticeObject.title;
        this.outline = this.noticeObject.outline;
        this.content = this.noticeObject.detail;
        this.isActive = this.noticeObject.is_active;
        this.schoolShareOnly = this.noticeObject.share_level_id != 3;
        if (this.schoolShareOnly) {
          this.fetchSharedSchools();
        }
      }
    }
  },
  mounted() {
    // this.loading = true
    this.fetchOrganisations();
  },
  methods: {
    fetchTypeData(type) {
      BaseService.getAll("archon/office/schools?types=" + type)
        .then((response) => (this.schoolList = response.data.data))
        .catch((err) => {
          console.log("Schools " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    fetchOrganisations() {
      BaseService.getAll("archon/office/schools?types=organisation")
        .then((response) => (this.organisationList = response.data.data))
        .catch((err) => {
          console.log("Schools " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    fetchConsuls() {
      BaseService.getAll(
        "archon/office/schools/" + this.orgSelected.id + "/consuls"
      )
        .then((response) => (this.schoolList = response.data))
        .catch((err) => {
          console.log("Schools " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    fetchSharedSchools() {
      BaseService.getAll(
        "archon/office/posts/" +
          this.noticeObject.identifier +
          "/shared/schools"
      )
        .then((response) => (this.selectedSchools = response.data.data))
        .catch((err) => {
          console.log("Schools shared" + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    userDidSelectType(type) {
      this.orgSelected = {};
      this.typeSelected = type;
      if (type.id === 0) {
        this.schoolList = [];
      } else {
        this.fetchTypeData(this.typeSelected.key);
      }
    },
    userDidSelectOrg(org) {
      this.typeSelected = this.typeList[0];
      this.userDidSelectType(this.typeSelected);

      this.orgSelected = org;
      if (org.id === 0) {
        this.orgList = [];
        this.schoolList = [];
      } else {
        this.fetchConsuls();
      }
    },
    setSelectAll() {
      this.selectAll = !this.selectAll;
      if (this.selectAll == false) {
        this.selectedSchools = [];
      } else {
        this.selectedSchools = [];
        this.selectedSchools = this.selectedSchools.concat(this.filteredList);
      }
    },
    selectSchool(school) {
      if (this.selectedSchools.some((p) => p.id === school.id)) {
        this.selectedSchools.splice(
          this.selectedSchools.findIndex((item) => item.id === school.id),
          1
        );
      } else {
        this.selectedSchools.push(school);
      }
    },
    isSelected(school) {
      if (this.selectedSchools.some((p) => p.id === school.id)) {
        return true;
      } else {
        return false;
      }
    },
    submitForm() {
      this.isSaving = true;

      if (this.$refs.form.requestSubmit === undefined) {
        this.submitNotice();
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    alertDisplay() {
      this.$swal({
        title: "Empty Fields",
        text: "You have empty fields that are required",
        type: "warning",
        showCancelButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: true,
      });
    },
    submitNotice() {
      if (this.outline == "" || this.title === "") {
        this.alertDisplay();
        this.isSaving = false;
      } else {
        this.processNotice();
      }
    },
    processNotice() {
      let calendarYear = calendarYearList().find((y) => y.current === true);

      let noticeTitle = this.title.trim();
      let noticeOutline = this.outline.trim();
      let payload = {
        title: noticeTitle,
        outline: noticeOutline,
        detail: this.content,
        post_type_id: 4,
        calendar_schoolyear: calendarYear.value,
        user_id: this.currentUser.teacherID,
        share_level_id: this.schoolShareOnly === false ? 3 : 4,
        is_active: this.isActive,
        identifier: undefined,
      };

      // schools shared
      if (this.schoolShareOnly) {
        payload.post_shared_schools = this.selectedSchools.map((s) => ({
          school_id: s.id,
        }));
      }

      // add new or update
      if (this.noticeObject.identifier === undefined) {
        PostService.add(payload)
          .then((response) => {
            this.noticeObject.identifier = response.data.identifier;
            this.completion(noticeOutline + " created");
          })
          .catch((err) => {
            this.completion(noticeOutline + " error");
            console.log("Notice add error " + err);
          });
      } else {
        payload.identifier = this.noticeObject.identifier;
        PostService.update(payload, this.noticeObject.identifier)
          .then((response) => this.completion(noticeOutline + " updated"))
          .catch((err) => {
            this.completion(noticeOutline + " error");
            console.log("Notice update error " + err);
          });
      }
    },
    completion(msg) {
      this.isSaving = false;
      this.$router.push({
        path: "/notices",
        params: { msg: msg },
      });
    },
    closeWindow() {
      this.$router.push({ path: "/notices" });
      window.scrollTo(0, 0);
    },
    deletion() {
      this.$swal({
        title: "Are you sure you want to delete?",
        text: "You will not be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete!",
      }).then((result) => {
        if (result.value === true) {
          this.processDelete();
        }
      });
    },
    processDelete() {
      PostService.delete(this.noticeObject)
        .then((response) =>
          this.completion(this.noticeTitle + " deleted from the system")
        )
        .catch((err) => {
          console.log(err);
        });
    },
    closeAddSchools() {
      this.showModalAddition = false;
    },
  },
  components: {
    savenotice,
    innertopbar,
    dropdown,
    VueEditor,
    ModalSlide
  },
};
</script>


<style scoped>
.off {
  margin-right: 11px;
}

.form-group span {
  font-weight: 400 !important;
}
.form-group.buttons a {
  margin-bottom: 19px;
}

.text-red .icon {
  color: #f56a6a;
}

.ql-snow .ql-editor h1 {
  font-size: 1.1em !important;
  margin-bottom: 8px !important;
}

.ql-snow .ql-editor h2 {
  font-size: 0.9em !important;
  margin-bottom: 8px !important;
}

.ql-snow .ql-editor h3 {
  font-size: 0.8em !important;
  margin-bottom: 8px !important;
}

.ql-editor {
  min-height: 350px !important;
}

.small .ql-editor {
  min-height: 130px !important;
}

.ql-editor p {
  @apply text-sm !important mb-3  !important;
  font-size: 0.83rem !important;
}

.ql-editor ul {
  @apply text-sm !important mb-3  !important;
}

.tb-actions a,
.selectable {
  cursor: pointer !important;
}

.selectable {
  padding-left: 11px;
}

.selectable i {
  font-size: 20px;
}

.selectable i.on {
  color: #f0ad4e !important;
}
</style>
